import BaseModal from "../../BaseComponents/BaseModal/BaseModal";
import { ArrowDownCircle, ArrowUpCircle, Calendar, CreditCard, Building2, DollarSign, FileText } from "lucide-react";
import styles from "./ViewTransactionModal.module.css";

const ViewTransactionModal = ({ open, onClose, transaction }) => {
  if (!transaction) return null;

  const isIncoming = transaction.direction === "Incoming";

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title="Transaction Details"
      width="680px"
      footer={
        <button className={styles.closeBtn} onClick={onClose}>
          Close
        </button>
      }
    >
      <div className={styles.transactionHeader}>
        <div className={`${styles.transactionIcon} ${isIncoming ? styles.iconIncoming : styles.iconOutgoing}`}>
          {isIncoming ? <ArrowDownCircle size={28} /> : <ArrowUpCircle size={28} />}
        </div>
        <div>
          <div className={styles.transactionRef}>{transaction.transactionRef}</div>
          <div className={styles.transactionSubtitle}>
            {transaction.direction} • {transaction.type}
          </div>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionTitle}>Transaction Information</div>
        <div className={styles.grid}>
          <div className={styles.field}>
            <div className={styles.label}>Transaction #</div>
            <div className={styles.value}>{transaction.transactionRef}</div>
          </div>
          <div className={styles.field}>
            <div className={styles.label}>Transaction Date</div>
            <div className={styles.value}>
              <Calendar size={14} className={styles.icon} />
              {transaction.date}
            </div>
          </div>
          <div className={styles.field}>
            <div className={styles.label}>Direction</div>
            <div className={styles.value}>
              <span className={`${styles.badge} ${isIncoming ? styles.badgeIncoming : styles.badgeOutgoing}`}>
                {transaction.direction}
              </span>
            </div>
          </div>
          <div className={styles.field}>
            <div className={styles.label}>Type</div>
            <div className={styles.value}>
              <span className={styles.badge}>{transaction.type}</span>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionTitle}>
          {transaction.entityType} Information
        </div>
        <div className={styles.grid}>
          <div className={styles.field}>
            <div className={styles.label}>Name</div>
            <div className={styles.value}>{transaction.entityName}</div>
          </div>
          <div className={styles.field}>
            <div className={styles.label}>Email</div>
            <div className={styles.value}>{transaction.entityEmail}</div>
          </div>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionTitle}>Booking & Payment Details</div>
        <div className={styles.grid}>
          <div className={styles.field}>
            <div className={styles.label}>Booking Reference</div>
            <div className={styles.value}>
              <span className={styles.bookingRef}>{transaction.bookingRef}</span>
            </div>
          </div>
          <div className={styles.field}>
            <div className={styles.label}>Payment Reference</div>
            <div className={styles.value}>
              <FileText size={14} className={styles.icon} />
              <span className={styles.paymentRef}>{transaction.reference}</span>
            </div>
          </div>
          <div className={styles.field}>
            <div className={styles.label}>Payment Method</div>
            <div className={styles.value}>
              <CreditCard size={14} className={styles.icon} />
              {transaction.paymentMethod}
            </div>
          </div>
          <div className={styles.field}>
            <div className={styles.label}>Account</div>
            <div className={styles.value}>
              <Building2 size={14} className={styles.icon} />
              {transaction.account}
            </div>
          </div>
          {transaction.airlinePnr && (
            <div className={styles.field}>
              <div className={styles.label}>Airline PNR</div>
              <div className={styles.value}>{transaction.airlinePnr}</div>
            </div>
          )}
          {transaction.supplierReferenceNo && (
            <div className={styles.field}>
              <div className={styles.label}>Supplier Reference No</div>
              <div className={styles.value}>{transaction.supplierReferenceNo}</div>
            </div>
          )}
          {transaction.transactionId && (
            <div className={styles.field}>
              <div className={styles.label}>Transaction ID</div>
              <div className={styles.value}>{transaction.transactionId}</div>
            </div>
          )}
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionTitle}>Amount</div>
        <div className={`${styles.amountBox} ${isIncoming ? styles.amountBoxIncoming : styles.amountBoxOutgoing}`}>
          <DollarSign size={20} />
          <div className={styles.amountValue}>
            {isIncoming ? "+" : "-"}
            € {transaction.amount.toLocaleString('de-DE', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}
          </div>
          <div className={styles.currency}>{transaction.currency}</div>
        </div>
      </div>

      {transaction.notes && (
        <div className={styles.section}>
          <div className={styles.sectionTitle}>Notes</div>
          <div className={styles.notesBox}>{transaction.notes}</div>
        </div>
      )}
    </BaseModal>
  );
};

export default ViewTransactionModal;